import React from 'react';
import Select from 'react-select';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Avatar from '../Avatar';
import '../../assets/styles/react-select.scss';

const MemberMultiSelectDropdown = ({
  id,
  labelText,
  name,
  fromArray,
  formProps,
  isDisabled,
  innerRef,
}) => {
  // Select option items
  const options = fromArray.map((member) => ({
    value: member.email,
    label: (
      <>
        <div className="avatar avatar-xs me-3">
          <Avatar
            firstName={member.firstName}
            lastName={member.lastName}
            imgPath={member.avatar ? member.avatar : ''}
          />
        </div>
        <span className="member-name">
          {member.firstName} {member.lastName}
        </span>
      </>
    ),
  }));

  return (
    <Form.Group controlId={id}>
      <Form.Label>{labelText}</Form.Label>
      <Select
        ref={innerRef}
        name={name}
        options={options}
        isMulti
        isClearable
        className="basic-multi-select"
        classNamePrefix="select"
        isDisabled={isDisabled}
        onChange={(option) =>
          formProps.setFieldValue(
            name,
            option.map((item) => item.value)
          )
        }
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#0649b5',
            neutral10: '#edf2f9',
            neutral20: '#d2ddec',
            neutral30: '#d2ddec',
            neutral50: '#b1c2da',
            neutral80: '#12263f',
            dangerLight: '#DEEBFF',
            danger: '#12263f',
          },
        })}
      />
    </Form.Group>
  );
};

MemberMultiSelectDropdown.propTypes = {
  id: PropTypes.string,
  fromArray: PropTypes.array,
  name: PropTypes.string,
  labelText: PropTypes.string,
  formProps: PropTypes.any,
  isDisabled: PropTypes.bool,
  innerRef: PropTypes.any,
};

export default MemberMultiSelectDropdown;
